import { useEffect } from "react";

/**
 * Sets a `--sbw` CSS custom property on <html> equal to the current vertical
 * scrollbar width in pixels (0 on mobile / overlay scrollbars, ~15 on macOS
 * "Always show" / Windows / Linux classic scrollbars). Used by the transition
 * overlays so their right edge lines up exactly with the underlying page
 * content (which is body-width = innerWidth − scrollbar), preventing a
 * visible horizontal jump at the moment the overlay disappears.
 *
 * Re-measures on window resize because scrollbar visibility / width can
 * change (e.g. orientation change on tablets, OS scrollbar settings).
 */
export default function useScrollbarGutterVar() {
  useEffect(() => {
    const measure = () => {
      const sbw =
        window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty(
        "--sbw",
        `${sbw > 0 ? sbw : 0}px`
      );
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);
}
